"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.headingSix = exports.headingFive = exports.headingFour = exports.headingThree = exports.labelFive = exports.labelFour = exports.labelThree = exports.labelTwo = exports.labelOne = exports.labelSmall = exports.label = exports.title = exports.headingTwo = exports.headingOne = exports.captionSmall = exports.captionExtraBold = exports.captionBold = exports.captionMedium = exports.caption = exports.strong = exports.emphasis = exports.body = exports.bodyLargeBold = exports.bodyLargeMedium = exports.bodyLarge = exports.subHeadingBold = exports.subHeadingMedium = exports.subHeading = exports.pageHeading = exports.displaySmall = exports.displayMedium = exports.displayLarge = exports.displayXLarge = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var styled_components_1 = require("styled-components");
var make_font_scale_1 = require("./make-font-scale");
exports.displayXLarge = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.BOLD', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(11, theme);
});
exports.displayLarge = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.BOLD', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(10, theme);
});
exports.displayMedium = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.BOLD', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(9, theme);
});
exports.displaySmall = (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.BOLD', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(8, theme);
});
exports.pageHeading = (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.BOLD', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(7, theme);
});
exports.subHeading = (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.REGULAR', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(6, theme);
});
exports.subHeadingMedium = (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.MEDIUM', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(6, theme);
});
exports.subHeadingBold = (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.BOLD', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(6, theme);
});
exports.bodyLarge = (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.REGULAR', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(5, theme);
});
exports.bodyLargeMedium = (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.MEDIUM', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(5, theme);
});
exports.bodyLargeBold = (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.BOLD', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(5, theme);
});
exports.body = (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.REGULAR', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(4, theme);
});
exports.emphasis = (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.MEDIUM', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(4, theme);
});
exports.strong = (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.BOLD', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(4, theme);
});
exports.caption = (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.REGULAR', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(3, theme);
});
exports.captionMedium = (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.MEDIUM', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(3, theme);
});
exports.captionBold = (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.BOLD', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(3, theme);
});
exports.captionExtraBold = (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.BLACK', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(3, theme);
});
exports.captionSmall = (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.MEDIUM', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(2, theme);
});
exports.headingOne = (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.DISPLAY.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.DISPLAY.BOLD', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(8, theme);
});
exports.headingTwo = (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.DISPLAY.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.DISPLAY.BOLD', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(7, theme);
});
exports.title = (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  font-style: normal;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.DISPLAY.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.DISPLAY.REGULAR', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(8, theme);
});
exports.label = (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-style: normal;\n  font-weight: ", ";\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n"], ["\n  font-family: ", ";\n  font-style: normal;\n  font-weight: ", ";\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.FONT', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('TYPOGRAPHY.TEXT.BLACK', theme);
});
exports.labelSmall = (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), exports.label, function (_a) {
    var theme = _a.theme;
    return (0, make_font_scale_1.makeFontScale)(1, theme);
});
exports.labelOne = exports.emphasis;
exports.labelTwo = exports.captionMedium;
exports.labelThree = exports.caption;
exports.labelFour = exports.captionBold;
exports.labelFive = exports.captionSmall;
exports.headingThree = exports.subHeadingMedium;
exports.headingFour = exports.bodyLargeMedium;
exports.headingFive = exports.strong;
exports.headingSix = exports.emphasis;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;
//# sourceMappingURL=index.js.map